let aboutData = {
    "description":"I'm Natalie Nguyen, a software engineer. I have experienced Software Engineer with a Master of Science in Computer Science. Skilled in the development of applications using ASP.NET, MVC, REST API, Entity Framework, SQL Server, JSON and XML Web Services, CSS, and JavaScript libraries such as JQuery and ReactJS. Strong background in computer science and a commitment to delivering high-quality software solutions.",
    "name": "Natalie Nguyen",
    "phone": "+1(714)-487-2807",
    "email": "natalie.nutm@gmail.com",
    "resume":"Natalie_Nguyen_SoftwareEngineer.pdf"
};
export default aboutData;